













import { Component, Prop, mixins } from 'nuxt-property-decorator'
import { defineComponent } from '@nuxtjs/composition-api'
import { SectionCore } from '@/mixins/sectionCore'
import SectionBasic from '@/components/SectionBasic.vue'
import BlockBanner from '@/components/BlockBanner.vue'
import BlockText from '@/components/BlockText.vue'

@Component
class SectionBlockBanner extends mixins(SectionCore) {
  @Prop() readonly bannerData: Object = {}
}

export default defineComponent({
  name: 'SectionBlockBanner',
  components: {
    SectionBasic,
    BlockBanner,
    BlockText,
  },
  props: SectionBlockBanner.options.props,

  setup() {},
})
